import ResumeItem from '@/common/components/ResumeItem'
import { formatPercentage } from '@/common/utils/formatters'
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react'

interface ProposalAwareResumeItemProps {
  label: string
  originalValue: number
  newValue: number | null | undefined
  differencePercentage?: string | number | null
  format: (value: number) => string
  higherIsBetter?: boolean
}

const ProposalAwareResumeItem = ({
  label,
  originalValue,
  newValue,
  differencePercentage,
  format,
  higherIsBetter = false,
}: ProposalAwareResumeItemProps) => {
  if (newValue == null) {
    return <ResumeItem className="text-sm" label={label} value={format(originalValue)} />
  }

  const increased = newValue > originalValue
  const isImprovement = higherIsBetter ? increased : newValue < originalValue
  const changeClass = newValue === originalValue ? '' : isImprovement ? 'text-valid' : 'text-danger-soft'

  const percentage = differencePercentage != null ? Number(differencePercentage) : 0

  return (
    <ResumeItem
      className="text-sm"
      label={label}
      value={
        <span className="flex items-center gap-1">
          <span className={changeClass}>{format(newValue)}</span>

          <span className="text-xs text-white-400 line-through">{format(originalValue)}</span>

          {percentage !== 0 && (
            <span className="text-[9px] text-white-800 rounded-full px-1 bg-yellow-op-2 inline-flex items-center">
              {increased ? (
                <ArrowUpIcon className={`size-3 ${changeClass}`} />
              ) : (
                <ArrowDownIcon className={`size-3 ${changeClass}`} />
              )}
              {formatPercentage(Math.abs(percentage), 0)}
            </span>
          )}
        </span>
      }
    />
  )
}

export default ProposalAwareResumeItem
